module.exports = __webpack_public_path__ + "static/media/2.bcf6de1d.png";